import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/safety/task";

export default {
    /** 列表数据 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存数据 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 查询项目下的部门负责人 */
    queryManagerList: (projectId) => axios.get({url: `${PREFIX_URI}/queryManagerList`, data: {projectId}}),

}